<div class="reopen-request">
  <div class="mb-16">
    <h1>Reabertura de pedido</h1>
  </div>

  <div class="mb-16">
    <scc-dsm3-select-control
      [formGroup]="viewModel?.formGroup"
      formName="reason"
      [options$]="viewModel?.$reasons"
      [errorsMessage]="{ required: 'O campo é obrigatório' }"
    ></scc-dsm3-select-control>
  </div>

  <div class="mb-16">
    <scc-dsm3-textarea-control
      [formGroup]="viewModel?.formGroup"
      formName="description"
      placeholder="Observações"
      [maxlength]="9999"
      [errorsMessage]="{ required: 'O campo é obrigatório' }"
      [counter]="false"
    >
    </scc-dsm3-textarea-control>
  </div>

  <div class="button-wrapper">
    <button class="btn-white-bggrey" (click)="onClickCancel()">Cancelar</button>

    <button class="btn-primary-yellow" (click)="onClickSubmit()" [disabled]="!viewModel?.formGroup?.valid">
      Enviar
    </button>
  </div>
</div>
